function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    role: "img",
    "aria-label": "Previous",
    focusable: "false",
    style: {
      "height": 20,
      "width": 20,
      "display": "block",
      "fill": "currentcolor"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/prev.b09192b4.svg";
export { SvgComponent as ReactComponent };